import React, { useState } from 'react';

function SurveyStepTwenty({ formData, onNext }) {
    const [onboardingRating, setOnboardingRating] = useState(formData.onboardingRating || '');
    const [onboardingComments, setOnboardingComments] = useState(formData.onboardingComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!onboardingRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ onboardingRating, onboardingComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 5: Employee Experience</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How would you rate the onboarding experience when you first joined? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`onboarding-rating-${option}`}
                            name="onboardingRating"
                            value={option}
                            checked={onboardingRating === option}
                            onChange={() => setOnboardingRating(option)}
                        />
                        <label htmlFor={`onboarding-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={onboardingComments}
                    onChange={(e) => setOnboardingComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!onboardingRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwenty;
